/* tslint:disable */
/* eslint-disable */
/**
 * AI Secretary
 * AI-powered voice assistant platform for automated appointment scheduling, customer communication, and CRM integration
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { CallbackCreateDTO } from '../models';
// @ts-ignore
import type { CallbackResponseDTO } from '../models';
// @ts-ignore
import type { CallbackSearchResponseDTO } from '../models';
// @ts-ignore
import type { CallbackState } from '../models';
// @ts-ignore
import type { CallbackUpdateDTO } from '../models';
// @ts-ignore
import type { CallbackWithCallLogDTO } from '../models';
// @ts-ignore
import type { HTTPValidationError } from '../models';
// @ts-ignore
import type { PageCallbackResponseDTO } from '../models';
/**
 * CallbacksApi - axios parameter creator
 * @export
 */
export const CallbacksApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Create a new callback request
         * @summary Create Callback
         * @param {CallbackCreateDTO} callbackCreateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCallbackApiV1CallbacksPost: async (callbackCreateDTO: CallbackCreateDTO, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'callbackCreateDTO' is not null or undefined
            assertParamExists('createCallbackApiV1CallbacksPost', 'callbackCreateDTO', callbackCreateDTO)
            const localVarPath = `/api/v1/callbacks`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(callbackCreateDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a new callback request
         * @summary Create Callback
         * @param {CallbackCreateDTO} callbackCreateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCallbackApiV1CallbacksPost_1: async (callbackCreateDTO: CallbackCreateDTO, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'callbackCreateDTO' is not null or undefined
            assertParamExists('createCallbackApiV1CallbacksPost_1', 'callbackCreateDTO', callbackCreateDTO)
            const localVarPath = `/api/v1/callbacks`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(callbackCreateDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a specific callback by ID
         * @summary Get Callback
         * @param {string} callbackId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCallbackApiV1CallbacksCallbackIdGet: async (callbackId: string, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'callbackId' is not null or undefined
            assertParamExists('getCallbackApiV1CallbacksCallbackIdGet', 'callbackId', callbackId)
            const localVarPath = `/api/v1/callbacks/{callback_id}`
                .replace(`{${"callback_id"}}`, encodeURIComponent(String(callbackId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a specific callback by ID
         * @summary Get Callback
         * @param {string} callbackId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCallbackApiV1CallbacksCallbackIdGet_2: async (callbackId: string, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'callbackId' is not null or undefined
            assertParamExists('getCallbackApiV1CallbacksCallbackIdGet_2', 'callbackId', callbackId)
            const localVarPath = `/api/v1/callbacks/{callback_id}`
                .replace(`{${"callback_id"}}`, encodeURIComponent(String(callbackId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a callback with associated call log data
         * @summary Get Callback With Call Log
         * @param {string} callbackId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCallbackWithCallLogApiV1CallbacksCallbackIdWithCallLogGet: async (callbackId: string, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'callbackId' is not null or undefined
            assertParamExists('getCallbackWithCallLogApiV1CallbacksCallbackIdWithCallLogGet', 'callbackId', callbackId)
            const localVarPath = `/api/v1/callbacks/{callback_id}/with-call-log`
                .replace(`{${"callback_id"}}`, encodeURIComponent(String(callbackId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a callback with associated call log data
         * @summary Get Callback With Call Log
         * @param {string} callbackId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCallbackWithCallLogApiV1CallbacksCallbackIdWithCallLogGet_3: async (callbackId: string, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'callbackId' is not null or undefined
            assertParamExists('getCallbackWithCallLogApiV1CallbacksCallbackIdWithCallLogGet_3', 'callbackId', callbackId)
            const localVarPath = `/api/v1/callbacks/{callback_id}/with-call-log`
                .replace(`{${"callback_id"}}`, encodeURIComponent(String(callbackId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List all callbacks for the organization
         * @summary List Callbacks
         * @param {CallbackState | null} [state] Filter by state (pending, tried, completed, failed)
         * @param {boolean} [pendingOnly] Only return pending callbacks (deprecated, use state&#x3D;pending)
         * @param {boolean} [completedOnly] Only return completed callbacks (deprecated, use state&#x3D;completed)
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCallbacksApiV1CallbacksGet: async (state?: CallbackState | null, pendingOnly?: boolean, completedOnly?: boolean, limit?: number, offset?: number, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/callbacks`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (state !== undefined) {
                localVarQueryParameter['state'] = state;
            }

            if (pendingOnly !== undefined) {
                localVarQueryParameter['pending_only'] = pendingOnly;
            }

            if (completedOnly !== undefined) {
                localVarQueryParameter['completed_only'] = completedOnly;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List all callbacks for the organization
         * @summary List Callbacks
         * @param {CallbackState | null} [state] Filter by state (pending, tried, completed, failed)
         * @param {boolean} [pendingOnly] Only return pending callbacks (deprecated, use state&#x3D;pending)
         * @param {boolean} [completedOnly] Only return completed callbacks (deprecated, use state&#x3D;completed)
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCallbacksApiV1CallbacksGet_4: async (state?: CallbackState | null, pendingOnly?: boolean, completedOnly?: boolean, limit?: number, offset?: number, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/callbacks`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (state !== undefined) {
                localVarQueryParameter['state'] = state;
            }

            if (pendingOnly !== undefined) {
                localVarQueryParameter['pending_only'] = pendingOnly;
            }

            if (completedOnly !== undefined) {
                localVarQueryParameter['completed_only'] = completedOnly;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List callbacks for a specific phone number
         * @summary List Callbacks By Phone
         * @param {string} phoneNumber Phone number to filter by
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCallbacksByPhoneApiV1CallbacksByPhoneGet: async (phoneNumber: string, limit?: number, offset?: number, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'phoneNumber' is not null or undefined
            assertParamExists('listCallbacksByPhoneApiV1CallbacksByPhoneGet', 'phoneNumber', phoneNumber)
            const localVarPath = `/api/v1/callbacks/by-phone`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (phoneNumber !== undefined) {
                localVarQueryParameter['phone_number'] = phoneNumber;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List callbacks for a specific phone number
         * @summary List Callbacks By Phone
         * @param {string} phoneNumber Phone number to filter by
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCallbacksByPhoneApiV1CallbacksByPhoneGet_5: async (phoneNumber: string, limit?: number, offset?: number, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'phoneNumber' is not null or undefined
            assertParamExists('listCallbacksByPhoneApiV1CallbacksByPhoneGet_5', 'phoneNumber', phoneNumber)
            const localVarPath = `/api/v1/callbacks/by-phone`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (phoneNumber !== undefined) {
                localVarQueryParameter['phone_number'] = phoneNumber;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Full-text search callbacks (tickets) with real total count
         * @summary Search Callbacks
         * @param {string} q Full-text search query
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {CallbackState | null} [state] Additionally filter by state (combined with search as AND)
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchCallbacksApiV1CallbacksSearchGet: async (q: string, limit?: number, offset?: number, state?: CallbackState | null, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'q' is not null or undefined
            assertParamExists('searchCallbacksApiV1CallbacksSearchGet', 'q', q)
            const localVarPath = `/api/v1/callbacks/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (state !== undefined) {
                localVarQueryParameter['state'] = state;
            }


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Full-text search callbacks (tickets) with real total count
         * @summary Search Callbacks
         * @param {string} q Full-text search query
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {CallbackState | null} [state] Additionally filter by state (combined with search as AND)
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchCallbacksApiV1CallbacksSearchGet_6: async (q: string, limit?: number, offset?: number, state?: CallbackState | null, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'q' is not null or undefined
            assertParamExists('searchCallbacksApiV1CallbacksSearchGet_6', 'q', q)
            const localVarPath = `/api/v1/callbacks/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (state !== undefined) {
                localVarQueryParameter['state'] = state;
            }


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update a callback state
         * @summary Update Callback
         * @param {string} callbackId 
         * @param {CallbackUpdateDTO} callbackUpdateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCallbackApiV1CallbacksCallbackIdPatch: async (callbackId: string, callbackUpdateDTO: CallbackUpdateDTO, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'callbackId' is not null or undefined
            assertParamExists('updateCallbackApiV1CallbacksCallbackIdPatch', 'callbackId', callbackId)
            // verify required parameter 'callbackUpdateDTO' is not null or undefined
            assertParamExists('updateCallbackApiV1CallbacksCallbackIdPatch', 'callbackUpdateDTO', callbackUpdateDTO)
            const localVarPath = `/api/v1/callbacks/{callback_id}`
                .replace(`{${"callback_id"}}`, encodeURIComponent(String(callbackId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(callbackUpdateDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update a callback state
         * @summary Update Callback
         * @param {string} callbackId 
         * @param {CallbackUpdateDTO} callbackUpdateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCallbackApiV1CallbacksCallbackIdPatch_7: async (callbackId: string, callbackUpdateDTO: CallbackUpdateDTO, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'callbackId' is not null or undefined
            assertParamExists('updateCallbackApiV1CallbacksCallbackIdPatch_7', 'callbackId', callbackId)
            // verify required parameter 'callbackUpdateDTO' is not null or undefined
            assertParamExists('updateCallbackApiV1CallbacksCallbackIdPatch_7', 'callbackUpdateDTO', callbackUpdateDTO)
            const localVarPath = `/api/v1/callbacks/{callback_id}`
                .replace(`{${"callback_id"}}`, encodeURIComponent(String(callbackId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(callbackUpdateDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CallbacksApi - functional programming interface
 * @export
 */
export const CallbacksApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CallbacksApiAxiosParamCreator(configuration)
    return {
        /**
         * Create a new callback request
         * @summary Create Callback
         * @param {CallbackCreateDTO} callbackCreateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createCallbackApiV1CallbacksPost(callbackCreateDTO: CallbackCreateDTO, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CallbackResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createCallbackApiV1CallbacksPost(callbackCreateDTO, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CallbacksApi.createCallbackApiV1CallbacksPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create a new callback request
         * @summary Create Callback
         * @param {CallbackCreateDTO} callbackCreateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createCallbackApiV1CallbacksPost_1(callbackCreateDTO: CallbackCreateDTO, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CallbackResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createCallbackApiV1CallbacksPost_1(callbackCreateDTO, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CallbacksApi.createCallbackApiV1CallbacksPost_1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get a specific callback by ID
         * @summary Get Callback
         * @param {string} callbackId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCallbackApiV1CallbacksCallbackIdGet(callbackId: string, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CallbackResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCallbackApiV1CallbacksCallbackIdGet(callbackId, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CallbacksApi.getCallbackApiV1CallbacksCallbackIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get a specific callback by ID
         * @summary Get Callback
         * @param {string} callbackId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCallbackApiV1CallbacksCallbackIdGet_2(callbackId: string, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CallbackResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCallbackApiV1CallbacksCallbackIdGet_2(callbackId, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CallbacksApi.getCallbackApiV1CallbacksCallbackIdGet_2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get a callback with associated call log data
         * @summary Get Callback With Call Log
         * @param {string} callbackId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCallbackWithCallLogApiV1CallbacksCallbackIdWithCallLogGet(callbackId: string, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CallbackWithCallLogDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCallbackWithCallLogApiV1CallbacksCallbackIdWithCallLogGet(callbackId, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CallbacksApi.getCallbackWithCallLogApiV1CallbacksCallbackIdWithCallLogGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get a callback with associated call log data
         * @summary Get Callback With Call Log
         * @param {string} callbackId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCallbackWithCallLogApiV1CallbacksCallbackIdWithCallLogGet_3(callbackId: string, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CallbackWithCallLogDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCallbackWithCallLogApiV1CallbacksCallbackIdWithCallLogGet_3(callbackId, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CallbacksApi.getCallbackWithCallLogApiV1CallbacksCallbackIdWithCallLogGet_3']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * List all callbacks for the organization
         * @summary List Callbacks
         * @param {CallbackState | null} [state] Filter by state (pending, tried, completed, failed)
         * @param {boolean} [pendingOnly] Only return pending callbacks (deprecated, use state&#x3D;pending)
         * @param {boolean} [completedOnly] Only return completed callbacks (deprecated, use state&#x3D;completed)
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listCallbacksApiV1CallbacksGet(state?: CallbackState | null, pendingOnly?: boolean, completedOnly?: boolean, limit?: number, offset?: number, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageCallbackResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listCallbacksApiV1CallbacksGet(state, pendingOnly, completedOnly, limit, offset, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CallbacksApi.listCallbacksApiV1CallbacksGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * List all callbacks for the organization
         * @summary List Callbacks
         * @param {CallbackState | null} [state] Filter by state (pending, tried, completed, failed)
         * @param {boolean} [pendingOnly] Only return pending callbacks (deprecated, use state&#x3D;pending)
         * @param {boolean} [completedOnly] Only return completed callbacks (deprecated, use state&#x3D;completed)
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listCallbacksApiV1CallbacksGet_4(state?: CallbackState | null, pendingOnly?: boolean, completedOnly?: boolean, limit?: number, offset?: number, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageCallbackResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listCallbacksApiV1CallbacksGet_4(state, pendingOnly, completedOnly, limit, offset, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CallbacksApi.listCallbacksApiV1CallbacksGet_4']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * List callbacks for a specific phone number
         * @summary List Callbacks By Phone
         * @param {string} phoneNumber Phone number to filter by
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listCallbacksByPhoneApiV1CallbacksByPhoneGet(phoneNumber: string, limit?: number, offset?: number, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageCallbackResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listCallbacksByPhoneApiV1CallbacksByPhoneGet(phoneNumber, limit, offset, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CallbacksApi.listCallbacksByPhoneApiV1CallbacksByPhoneGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * List callbacks for a specific phone number
         * @summary List Callbacks By Phone
         * @param {string} phoneNumber Phone number to filter by
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listCallbacksByPhoneApiV1CallbacksByPhoneGet_5(phoneNumber: string, limit?: number, offset?: number, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageCallbackResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listCallbacksByPhoneApiV1CallbacksByPhoneGet_5(phoneNumber, limit, offset, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CallbacksApi.listCallbacksByPhoneApiV1CallbacksByPhoneGet_5']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Full-text search callbacks (tickets) with real total count
         * @summary Search Callbacks
         * @param {string} q Full-text search query
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {CallbackState | null} [state] Additionally filter by state (combined with search as AND)
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchCallbacksApiV1CallbacksSearchGet(q: string, limit?: number, offset?: number, state?: CallbackState | null, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CallbackSearchResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchCallbacksApiV1CallbacksSearchGet(q, limit, offset, state, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CallbacksApi.searchCallbacksApiV1CallbacksSearchGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Full-text search callbacks (tickets) with real total count
         * @summary Search Callbacks
         * @param {string} q Full-text search query
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {CallbackState | null} [state] Additionally filter by state (combined with search as AND)
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchCallbacksApiV1CallbacksSearchGet_6(q: string, limit?: number, offset?: number, state?: CallbackState | null, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CallbackSearchResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchCallbacksApiV1CallbacksSearchGet_6(q, limit, offset, state, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CallbacksApi.searchCallbacksApiV1CallbacksSearchGet_6']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update a callback state
         * @summary Update Callback
         * @param {string} callbackId 
         * @param {CallbackUpdateDTO} callbackUpdateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateCallbackApiV1CallbacksCallbackIdPatch(callbackId: string, callbackUpdateDTO: CallbackUpdateDTO, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CallbackResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateCallbackApiV1CallbacksCallbackIdPatch(callbackId, callbackUpdateDTO, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CallbacksApi.updateCallbackApiV1CallbacksCallbackIdPatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update a callback state
         * @summary Update Callback
         * @param {string} callbackId 
         * @param {CallbackUpdateDTO} callbackUpdateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateCallbackApiV1CallbacksCallbackIdPatch_7(callbackId: string, callbackUpdateDTO: CallbackUpdateDTO, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CallbackResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateCallbackApiV1CallbacksCallbackIdPatch_7(callbackId, callbackUpdateDTO, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CallbacksApi.updateCallbackApiV1CallbacksCallbackIdPatch_7']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CallbacksApi - factory interface
 * @export
 */
export const CallbacksApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CallbacksApiFp(configuration)
    return {
        /**
         * Create a new callback request
         * @summary Create Callback
         * @param {CallbackCreateDTO} callbackCreateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCallbackApiV1CallbacksPost(callbackCreateDTO: CallbackCreateDTO, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<CallbackResponseDTO> {
            return localVarFp.createCallbackApiV1CallbacksPost(callbackCreateDTO, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Create a new callback request
         * @summary Create Callback
         * @param {CallbackCreateDTO} callbackCreateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCallbackApiV1CallbacksPost_1(callbackCreateDTO: CallbackCreateDTO, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<CallbackResponseDTO> {
            return localVarFp.createCallbackApiV1CallbacksPost_1(callbackCreateDTO, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Get a specific callback by ID
         * @summary Get Callback
         * @param {string} callbackId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCallbackApiV1CallbacksCallbackIdGet(callbackId: string, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<CallbackResponseDTO> {
            return localVarFp.getCallbackApiV1CallbacksCallbackIdGet(callbackId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Get a specific callback by ID
         * @summary Get Callback
         * @param {string} callbackId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCallbackApiV1CallbacksCallbackIdGet_2(callbackId: string, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<CallbackResponseDTO> {
            return localVarFp.getCallbackApiV1CallbacksCallbackIdGet_2(callbackId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Get a callback with associated call log data
         * @summary Get Callback With Call Log
         * @param {string} callbackId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCallbackWithCallLogApiV1CallbacksCallbackIdWithCallLogGet(callbackId: string, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<CallbackWithCallLogDTO> {
            return localVarFp.getCallbackWithCallLogApiV1CallbacksCallbackIdWithCallLogGet(callbackId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Get a callback with associated call log data
         * @summary Get Callback With Call Log
         * @param {string} callbackId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCallbackWithCallLogApiV1CallbacksCallbackIdWithCallLogGet_3(callbackId: string, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<CallbackWithCallLogDTO> {
            return localVarFp.getCallbackWithCallLogApiV1CallbacksCallbackIdWithCallLogGet_3(callbackId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * List all callbacks for the organization
         * @summary List Callbacks
         * @param {CallbackState | null} [state] Filter by state (pending, tried, completed, failed)
         * @param {boolean} [pendingOnly] Only return pending callbacks (deprecated, use state&#x3D;pending)
         * @param {boolean} [completedOnly] Only return completed callbacks (deprecated, use state&#x3D;completed)
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCallbacksApiV1CallbacksGet(state?: CallbackState | null, pendingOnly?: boolean, completedOnly?: boolean, limit?: number, offset?: number, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<PageCallbackResponseDTO> {
            return localVarFp.listCallbacksApiV1CallbacksGet(state, pendingOnly, completedOnly, limit, offset, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * List all callbacks for the organization
         * @summary List Callbacks
         * @param {CallbackState | null} [state] Filter by state (pending, tried, completed, failed)
         * @param {boolean} [pendingOnly] Only return pending callbacks (deprecated, use state&#x3D;pending)
         * @param {boolean} [completedOnly] Only return completed callbacks (deprecated, use state&#x3D;completed)
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCallbacksApiV1CallbacksGet_4(state?: CallbackState | null, pendingOnly?: boolean, completedOnly?: boolean, limit?: number, offset?: number, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<PageCallbackResponseDTO> {
            return localVarFp.listCallbacksApiV1CallbacksGet_4(state, pendingOnly, completedOnly, limit, offset, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * List callbacks for a specific phone number
         * @summary List Callbacks By Phone
         * @param {string} phoneNumber Phone number to filter by
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCallbacksByPhoneApiV1CallbacksByPhoneGet(phoneNumber: string, limit?: number, offset?: number, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<PageCallbackResponseDTO> {
            return localVarFp.listCallbacksByPhoneApiV1CallbacksByPhoneGet(phoneNumber, limit, offset, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * List callbacks for a specific phone number
         * @summary List Callbacks By Phone
         * @param {string} phoneNumber Phone number to filter by
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCallbacksByPhoneApiV1CallbacksByPhoneGet_5(phoneNumber: string, limit?: number, offset?: number, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<PageCallbackResponseDTO> {
            return localVarFp.listCallbacksByPhoneApiV1CallbacksByPhoneGet_5(phoneNumber, limit, offset, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Full-text search callbacks (tickets) with real total count
         * @summary Search Callbacks
         * @param {string} q Full-text search query
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {CallbackState | null} [state] Additionally filter by state (combined with search as AND)
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchCallbacksApiV1CallbacksSearchGet(q: string, limit?: number, offset?: number, state?: CallbackState | null, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<CallbackSearchResponseDTO> {
            return localVarFp.searchCallbacksApiV1CallbacksSearchGet(q, limit, offset, state, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Full-text search callbacks (tickets) with real total count
         * @summary Search Callbacks
         * @param {string} q Full-text search query
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {CallbackState | null} [state] Additionally filter by state (combined with search as AND)
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchCallbacksApiV1CallbacksSearchGet_6(q: string, limit?: number, offset?: number, state?: CallbackState | null, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<CallbackSearchResponseDTO> {
            return localVarFp.searchCallbacksApiV1CallbacksSearchGet_6(q, limit, offset, state, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Update a callback state
         * @summary Update Callback
         * @param {string} callbackId 
         * @param {CallbackUpdateDTO} callbackUpdateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCallbackApiV1CallbacksCallbackIdPatch(callbackId: string, callbackUpdateDTO: CallbackUpdateDTO, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<CallbackResponseDTO> {
            return localVarFp.updateCallbackApiV1CallbacksCallbackIdPatch(callbackId, callbackUpdateDTO, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Update a callback state
         * @summary Update Callback
         * @param {string} callbackId 
         * @param {CallbackUpdateDTO} callbackUpdateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCallbackApiV1CallbacksCallbackIdPatch_7(callbackId: string, callbackUpdateDTO: CallbackUpdateDTO, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<CallbackResponseDTO> {
            return localVarFp.updateCallbackApiV1CallbacksCallbackIdPatch_7(callbackId, callbackUpdateDTO, authorization, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CallbacksApi - object-oriented interface
 * @export
 * @class CallbacksApi
 * @extends {BaseAPI}
 */
export class CallbacksApi extends BaseAPI {
    /**
     * Create a new callback request
     * @summary Create Callback
     * @param {CallbackCreateDTO} callbackCreateDTO 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CallbacksApi
     */
    public createCallbackApiV1CallbacksPost(callbackCreateDTO: CallbackCreateDTO, authorization?: string, options?: RawAxiosRequestConfig) {
        return CallbacksApiFp(this.configuration).createCallbackApiV1CallbacksPost(callbackCreateDTO, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create a new callback request
     * @summary Create Callback
     * @param {CallbackCreateDTO} callbackCreateDTO 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CallbacksApi
     */
    public createCallbackApiV1CallbacksPost_1(callbackCreateDTO: CallbackCreateDTO, authorization?: string, options?: RawAxiosRequestConfig) {
        return CallbacksApiFp(this.configuration).createCallbackApiV1CallbacksPost_1(callbackCreateDTO, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get a specific callback by ID
     * @summary Get Callback
     * @param {string} callbackId 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CallbacksApi
     */
    public getCallbackApiV1CallbacksCallbackIdGet(callbackId: string, authorization?: string, options?: RawAxiosRequestConfig) {
        return CallbacksApiFp(this.configuration).getCallbackApiV1CallbacksCallbackIdGet(callbackId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get a specific callback by ID
     * @summary Get Callback
     * @param {string} callbackId 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CallbacksApi
     */
    public getCallbackApiV1CallbacksCallbackIdGet_2(callbackId: string, authorization?: string, options?: RawAxiosRequestConfig) {
        return CallbacksApiFp(this.configuration).getCallbackApiV1CallbacksCallbackIdGet_2(callbackId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get a callback with associated call log data
     * @summary Get Callback With Call Log
     * @param {string} callbackId 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CallbacksApi
     */
    public getCallbackWithCallLogApiV1CallbacksCallbackIdWithCallLogGet(callbackId: string, authorization?: string, options?: RawAxiosRequestConfig) {
        return CallbacksApiFp(this.configuration).getCallbackWithCallLogApiV1CallbacksCallbackIdWithCallLogGet(callbackId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get a callback with associated call log data
     * @summary Get Callback With Call Log
     * @param {string} callbackId 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CallbacksApi
     */
    public getCallbackWithCallLogApiV1CallbacksCallbackIdWithCallLogGet_3(callbackId: string, authorization?: string, options?: RawAxiosRequestConfig) {
        return CallbacksApiFp(this.configuration).getCallbackWithCallLogApiV1CallbacksCallbackIdWithCallLogGet_3(callbackId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List all callbacks for the organization
     * @summary List Callbacks
     * @param {CallbackState | null} [state] Filter by state (pending, tried, completed, failed)
     * @param {boolean} [pendingOnly] Only return pending callbacks (deprecated, use state&#x3D;pending)
     * @param {boolean} [completedOnly] Only return completed callbacks (deprecated, use state&#x3D;completed)
     * @param {number} [limit] 
     * @param {number} [offset] 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CallbacksApi
     */
    public listCallbacksApiV1CallbacksGet(state?: CallbackState | null, pendingOnly?: boolean, completedOnly?: boolean, limit?: number, offset?: number, authorization?: string, options?: RawAxiosRequestConfig) {
        return CallbacksApiFp(this.configuration).listCallbacksApiV1CallbacksGet(state, pendingOnly, completedOnly, limit, offset, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List all callbacks for the organization
     * @summary List Callbacks
     * @param {CallbackState | null} [state] Filter by state (pending, tried, completed, failed)
     * @param {boolean} [pendingOnly] Only return pending callbacks (deprecated, use state&#x3D;pending)
     * @param {boolean} [completedOnly] Only return completed callbacks (deprecated, use state&#x3D;completed)
     * @param {number} [limit] 
     * @param {number} [offset] 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CallbacksApi
     */
    public listCallbacksApiV1CallbacksGet_4(state?: CallbackState | null, pendingOnly?: boolean, completedOnly?: boolean, limit?: number, offset?: number, authorization?: string, options?: RawAxiosRequestConfig) {
        return CallbacksApiFp(this.configuration).listCallbacksApiV1CallbacksGet_4(state, pendingOnly, completedOnly, limit, offset, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List callbacks for a specific phone number
     * @summary List Callbacks By Phone
     * @param {string} phoneNumber Phone number to filter by
     * @param {number} [limit] 
     * @param {number} [offset] 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CallbacksApi
     */
    public listCallbacksByPhoneApiV1CallbacksByPhoneGet(phoneNumber: string, limit?: number, offset?: number, authorization?: string, options?: RawAxiosRequestConfig) {
        return CallbacksApiFp(this.configuration).listCallbacksByPhoneApiV1CallbacksByPhoneGet(phoneNumber, limit, offset, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List callbacks for a specific phone number
     * @summary List Callbacks By Phone
     * @param {string} phoneNumber Phone number to filter by
     * @param {number} [limit] 
     * @param {number} [offset] 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CallbacksApi
     */
    public listCallbacksByPhoneApiV1CallbacksByPhoneGet_5(phoneNumber: string, limit?: number, offset?: number, authorization?: string, options?: RawAxiosRequestConfig) {
        return CallbacksApiFp(this.configuration).listCallbacksByPhoneApiV1CallbacksByPhoneGet_5(phoneNumber, limit, offset, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Full-text search callbacks (tickets) with real total count
     * @summary Search Callbacks
     * @param {string} q Full-text search query
     * @param {number} [limit] 
     * @param {number} [offset] 
     * @param {CallbackState | null} [state] Additionally filter by state (combined with search as AND)
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CallbacksApi
     */
    public searchCallbacksApiV1CallbacksSearchGet(q: string, limit?: number, offset?: number, state?: CallbackState | null, authorization?: string, options?: RawAxiosRequestConfig) {
        return CallbacksApiFp(this.configuration).searchCallbacksApiV1CallbacksSearchGet(q, limit, offset, state, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Full-text search callbacks (tickets) with real total count
     * @summary Search Callbacks
     * @param {string} q Full-text search query
     * @param {number} [limit] 
     * @param {number} [offset] 
     * @param {CallbackState | null} [state] Additionally filter by state (combined with search as AND)
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CallbacksApi
     */
    public searchCallbacksApiV1CallbacksSearchGet_6(q: string, limit?: number, offset?: number, state?: CallbackState | null, authorization?: string, options?: RawAxiosRequestConfig) {
        return CallbacksApiFp(this.configuration).searchCallbacksApiV1CallbacksSearchGet_6(q, limit, offset, state, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update a callback state
     * @summary Update Callback
     * @param {string} callbackId 
     * @param {CallbackUpdateDTO} callbackUpdateDTO 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CallbacksApi
     */
    public updateCallbackApiV1CallbacksCallbackIdPatch(callbackId: string, callbackUpdateDTO: CallbackUpdateDTO, authorization?: string, options?: RawAxiosRequestConfig) {
        return CallbacksApiFp(this.configuration).updateCallbackApiV1CallbacksCallbackIdPatch(callbackId, callbackUpdateDTO, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update a callback state
     * @summary Update Callback
     * @param {string} callbackId 
     * @param {CallbackUpdateDTO} callbackUpdateDTO 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CallbacksApi
     */
    public updateCallbackApiV1CallbacksCallbackIdPatch_7(callbackId: string, callbackUpdateDTO: CallbackUpdateDTO, authorization?: string, options?: RawAxiosRequestConfig) {
        return CallbacksApiFp(this.configuration).updateCallbackApiV1CallbacksCallbackIdPatch_7(callbackId, callbackUpdateDTO, authorization, options).then((request) => request(this.axios, this.basePath));
    }
}

